import { useToastState } from "../../context/ToastContextProvider"
import { ToastMessage } from "../ToastMessage"

export const ToastsMessages = () => {
  const toasts = useToastState()

  if (Object.keys(toasts).length === 0) return null
  return (
    <div className="absolute m-10 mt-20 top-0 right-0">
      {Object.values(toasts).map((t) => (
        <ToastMessage
          key={t.id}
          id={t.id}
          status={t.status}
          header={t.header}
          text={t.text}
        />
      ))}
    </div>
  )
}
